import styled from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'
import { label } from 'app/livbrite/resources/theme/css'
import { BP } from 'resources/constants'
import caretDownWhiteSvg from 'resources/svg/icons/caret-down-white.svg'
import caretDownSvg from 'resources/svg/icons/caret-down.svg'

export const StyledForm = styled.div`
  .inline {
    display: flex;
    align-items: flex-end;

    > div {
      &:nth-child(even) {
        margin: 0 8px;
      }
    }
  }

  .bottom__checkbox {
    margin-bottom: 15px;

    > div {
      padding-bottom: 5px;
    }

    > label {
      span {
        font: ${font('default', 'normal', '14px/19px')};
        color: ${props => props.theme.palette.general.greyDark};
      }

      input {
        margin-right: 5px;
      }
    }
  }

  label {
    ${label}

    &.radio,
    &.checkbox {
      display: flex !important;
      align-items: center;
      cursor: pointer;
      padding: 5px 0;
      flex-wrap: wrap;

      span {
        user-select: none;
        ${bp('sm')`
          max-width: 80%;
        `}
      }

      input[type=radio],
      input[type=checkbox] {
        appearance: none;
        width: 30px;
        height: 20px;
        position: relative;

        &::before,
        &::after {
          content: '';
          display: block;
          box-sizing: border-box;
        }

        &::before {
          background: ${props => props.theme.palette.general.light};
          border: 2px solid ${props => props.theme.palette.primary.alpha};
        }

        &::after {
          position: absolute;
          background: ${props => props.theme.palette.primary.alpha};
          opacity: 0;
        }

        &:checked,
        &:focus {
          outline: none;
        }

        &:checked {
          &::after {
            opacity: 1;
          }
        }
      }
    }

    &.radio {
      input[type=radio] {
        &::before,
        &::after {
          border-radius: 50%;
        }

        &::before {
          width: 20px;
          height: 20px;
        }

        &::after {
          width: 12px;
          height: 12px;
          top: 4px;
          left: 4px;
        }
      }

      &.other {
        position: relative;
        margin-bottom: 50px;

        input[type=text] {
          height: 60px;
          position: absolute;
          top: 0;
          left: 100px;
          width: 70%;
        }
      }
    }

    &.checkbox {
      input[disabled],
      input[disabled] + span {
        opacity: 0.4;
      }

      input[type=checkbox] {
        &::before {
          width: 22px;
          height: 22px;
        }

        &::after {
          width: 14px;
          height: 14px;
          top: 4px;
          left: 4px;
        }
      }
    }
  }

  .child-options {
    padding: 10px 25px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;

    @media (max-width: ${BP.xs.max}) {
      width: 100%;
      flex-direction: column;
    }

    > label {
      font-size: 16px !important;
      margin: 0 5px;
    }
  }

  .text {
    height: 50px;
    border: 1px solid ${props => props.theme.palette.general.grey};
    border-radius: 2px;
    width: 100%;
    margin-bottom: 12px;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .submit {
    display: flex;
    justify-content: center;

    button {
      font-weight: bold;
      text-transform: uppercase;
    }
  }
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  ${bp('sm')`
    flex-wrap: wrap;
  `}

  > div {
    flex: 1;
    ${bp('sm')`
      flex: auto;
      width: 100%;
      margin-left: 0 !important;
    `}

    &:nth-child(even) {
      margin-left: 25px;
    }
  }

  &.address {
    > div:nth-child(even) {
      margin: 0 25px;
    }
  }
`

export const Actions = styled.div<any>`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  ${bp('sm')`
    flex-wrap: wrap;
  `}

  button {
    width: ${props => props.fullWidth ? '100%' : 'auto'};
    background-color: ${props => props.theme.palette.primary.alpha};
    font: ${font('default', 'bold', '20px/27px')};
    text-transform: uppercase;
    box-shadow: 0 2px 8px 2px ${props => props.theme.palette.general.grey};
    ${bp('sm')`
      width: 100%;
    `}

    &:last-child {
      margin: ${props => props.alignRight && '0 0 0 auto'};
      margin: ${props => props.alignLeft && '0 auto 0 0'};
    }
  }

  .button {
    &__mutted {
      background-color: ${props => props.theme.palette.general.grey};
      ${bp('sm')`
        order: 3;
        margin-top: 10px !important;
      `}
    }

    &__text {
      background: none;
      box-shadow: none;
      text-transform: none;
      font: ${font('default', 'normal', '16px/20px')};

      div {
        color: ${props => props.theme.palette.general.greyDark};
      }
    }
  }
`

export const StyledSelect = styled.div<any>`
  > div {
    > div:not(.react-select__menu) {
      &::before {
        content: '';
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;
        width: 25px;
        background: ${props => props.theme.form.passiveColor} url(${caretDownWhiteSvg}) center no-repeat;
        background-size: 15px;
        font-size: 20px;
        border-top-right-radius: 2px;
        border-bottom-right-radius: 2px;
      }
    }

    ${props => props.bottomSpace && `
      margin-bottom: 32px;
    `}
  }

  select {
    + svg {
      display: none !important;
    }
  }

  ${props => props.minimal && `
    display: flex;
    align-items: center;

    label {
      margin-right: 10px;

      &::after {
        content: ':';
      }
    }

    .react-select {
      &__control {
        border: none;

        &::before {
          background: transparent url(${caretDownSvg}) center no-repeat;
          background-size: 10px;
        }
      }

      &__value-container {
        min-width: 150px;
      }

      &__indicators {
        visibility: hidden;
      }

      &__placeholder {
        display: none;
      }
    }
  `}
`

export const StyledReactSelect = styled.div`
  .react-select {
    &__control {
      &--is-focused {
        border: none;
      }
    }
  }
`
